import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { SaxoLookUp, SaxoLookUpProperty } from '../models/Saxo-look-up';

@Injectable()
export class LookUpService {
  constructor(private http: HttpClient) {}

  getOccupation(): Observable<SaxoLookUp[]> {
    return this.getLookUp('occupation_types');
  }

  getNatureOfBusiness(): Observable<SaxoLookUp[]> {
    return this.getLookUp('nature_of_business_category');
  }

  getSubNatureOfBusiness(): Observable<SaxoLookUp[]> {
    return this.getLookUp('nature_of_business_subcategory');
  }

  getSourceOfFunds(): Observable<SaxoLookUp[]> {
    return this.getLookUp('primary_sources_of_wealth');
  }

  getNetWorthChf(): Observable<SaxoLookUp[]> {
    return this.getLookUp('net_worth_chf');
  }

  getLiquidAssetsChf(): Observable<SaxoLookUp[]> {
    return this.getLookUp('liquid_assets');
  }

  getIntendToInvest(): Observable<SaxoLookUp[]> {
    return this.getLookUp('intend_to_invest');
  }

  getAnnualIncomeChf(): Observable<SaxoLookUp[]> {
    return this.getLookUp('annual_income_chf');
  }

  getMaritalStatusIDs(): Observable<SaxoLookUp[]> {
    return this.getLookUp('marital_status');
  }

  getMaritalStatus3AIDs(): Observable<SaxoLookUp[]> {
    return this.getLookUp('marital_status_3a');
  }

  getEducationLevels(): Observable<SaxoLookUp[]> {
    return this.getLookUp('level_of_education');
  }

  getInvestmentServices(): Observable<SaxoLookUp[]> {
    return this.getLookUp('investment_service');
  }

  getEmploymentStatusList(): Observable<SaxoLookUp[]> {
    return this.getLookUp('employment_status');
  }

  getIndustryList(): Observable<SaxoLookUp[]> {
    return this.getLookUp('industry');
  }

  get3AEmploymentStatusList(): Observable<SaxoLookUp[]> {
    return this.getLookUp('employment_status_3a');
  }

  getLookUp(property: SaxoLookUpProperty): Observable<SaxoLookUp[]> {
    return this.http.get<SaxoLookUp[]>(`${environment.apiUrl}/look_up/${property}`);
  }
}
